import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "evCharger"
const EvChargerIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M8.674 8.441C8.954 8.201 9.414 8.438 9.345 8.83L8.937 11.16 10.481 11.36C10.803 11.403 10.953 11.782 10.746 12.032L7.88 15.505C7.61 15.83 7.082 15.588 7.155 15.17L7.562 12.84 6.02 12.64C5.697 12.597 5.547 12.218 5.754 11.968L8.62 8.496z" />
          <path
            fillRule="evenodd"
            d="M12.75 1.5C13.578 1.5 14.25 2.172 14.25 3V13.5H15.375C16.618 13.5 17.625 14.507 17.625 15.75V20.063C17.625 20.58 18.045 21 18.563 21 19.08 21 19.5 20.58 19.5 20.063V8.25H18.75C18.336 8.25 18 7.914 18 7.5V5.25C18 4.836 18.336 4.5 18.75 4.5V2.25H19.5V4.5H21V2.25H21.75V4.5C22.164 4.5 22.5 4.836 22.5 5.25V7.5C22.5 7.914 22.164 8.25 21.75 8.25H21V20.063C21 21.409 19.909 22.5 18.563 22.5 17.216 22.5 16.125 21.409 16.125 20.063V15.75C16.125 15.336 15.789 15 15.375 15H14.25V21L14.242 21.153C14.165 21.91 13.527 22.5 12.75 22.5H3.75C2.973 22.5 2.335 21.91 2.258 21.153L2.25 21V3C2.25 2.172 2.922 1.5 3.75 1.5zM3.75 21H12.75V3H3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EvChargerIcon
